import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var TextBaseline = /** @class */ (function (_super) {
    __extends(TextBaseline, _super);
    function TextBaseline() {
        return _super.call(this) || this;
    }
    TextBaseline.forceNativeConstructor = true;
    TextBaseline.forceNativeMethods = true;
    // JS -> AS Bindings
    TextBaseline.ROMAN = 'roman';
    TextBaseline.ASCENT = 'ascent';
    TextBaseline.DESCENT = 'descent';
    TextBaseline.IDEOGRAPHIC_TOP = 'ideographicTop';
    TextBaseline.IDEOGRAPHIC_CENTER = 'ideographicCenter';
    TextBaseline.IDEOGRAPHIC_BOTTOM = 'ideographicBottom';
    TextBaseline.USE_DOMINANT_BASELINE = 'useDominantBaseline';
    return TextBaseline;
}(ASObject));
export { TextBaseline };
